// extracted by mini-css-extract-plugin
module.exports = {"container":"ToFO6ErMo2ZkC36eBdOna"};